import { createElement } from "react";
import React from "react";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { uncurry2, createObj } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { mapIndexed, map } from "./fable_modules/fable-library-js.4.17.0/Array.js";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.17.0/Seq.js";
import { cons, empty as empty_1, singleton as singleton_1, ofArray, append as append_1 } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { useReact_useEffectOnce_3A5B6456, useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.2.7.0/React.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { ReviewMeta_$reflection, ShortEvent_$reflection, TopShortEntry_$reflection, InsiderTradeEvent_$reflection } from "./Types.js";
import { obj_type, array_type } from "./fable_modules/fable-library-js.4.17.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.17.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { unwrap, map as map_1, defaultArg } from "./fable_modules/fable-library-js.4.17.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { DataServerBaseUrl } from "./Components/Constants.js";
import { fromString } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { Format_formatSpacedNumber, Time_utcDateToLocalDayAndMonth } from "./Components/Utils.js";
import { LoadingIndicator_skeleton } from "./Components/Components.js";

function container(children) {
    return createElement("div", {
        style: {
            display: "flex",
            margin: 10,
            width: 100 + "%",
            flexGrow: 1,
            maxWidth: 1300,
            backgroundColor: "#FFFFFF",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

function section$0027(children) {
    return createElement("section", {
        style: {
            display: "flex",
            flexWrap: "wrap",
            flexGrow: 1,
            justifyContent: "space-between",
            paddingRight: 16,
            paddingLeft: 16,
            paddingBottom: 2 + "rem",
            paddingTop: 2 + "rem",
            gap: 40 + "px ",
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

function sectionContent(children) {
    return createElement("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
        },
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

function h3$0027(txt) {
    return createElement("h3", {
        style: {
            marginTop: 0,
            fontWeight: "bold",
        },
        children: txt,
    });
}

function thead$0027(headers) {
    let elems;
    const children = singleton_1(createElement("tr", createObj(ofArray([["style", {
        color: "var(--text-dim)",
    }], (elems = map((tupledArg) => createElement("th", createObj(toList(delay(() => append(tupledArg[2] ? singleton(["className", "hide-small-screens"]) : empty(), delay(() => append(singleton(["style", createObj(append_1(toList(delay(() => (tupledArg[1] ? singleton(["fontWeight", "bold"]) : empty()))), tupledArg[3]))]), delay(() => singleton(["children", tupledArg[0]]))))))))), headers), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))));
    return createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

function tickerTd(ticker, market) {
    let elems;
    return createElement("td", createObj(ofArray([["style", {
        fontWeight: "bold",
    }], (elems = [createElement("a", {
        style: {
            userSelect: "none",
        },
        href: `/stock/${market}/${ticker}`,
        children: ticker,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function assetTd(hideSmall, name, ticker, market) {
    return createElement("td", createObj(toList(delay(() => append(hideSmall ? singleton(["className", "hide-small-screens"]) : empty(), delay(() => {
        let elems;
        return singleton((elems = [createElement("a", {
            href: `/stock/${market}/${ticker}`,
            style: {
                userSelect: "none",
            },
            children: name,
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))]));
    }))))));
}

function InsiderTrade() {
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(InsiderTradeEvent_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty_1(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/insider-trade/latest`, properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(InsiderTradeEvent_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_3) => {
                const res = _arg_3;
                if (res.tag === 1) {
                    return Promise.resolve();
                }
                else {
                    patternInput[1](res.fields[0]);
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    });
    return container(singleton_1(section$0027(singleton_1(sectionContent(toList(delay(() => append(singleton(h3$0027("Siste innsidehandler")), delay(() => {
        let children_4, children_2;
        const matchValue_1 = patternInput[0];
        if (matchValue_1 != null) {
            const x_2 = matchValue_1;
            return singleton((children_4 = ofArray([thead$0027([["Dato", false, false, empty_1()], ["Ticker", false, false, empty_1()], ["Navn", false, true, empty_1()], ["Handel", false, false, empty_1()], ["Antall aksjer", false, true, singleton_1(["textAlign", "right"])]]), (children_2 = map((i) => {
                const children = ofArray([createElement("td", {
                    children: [Time_utcDateToLocalDayAndMonth(i.Date)],
                }), tickerTd(i.Ticker, i.Market), assetTd(true, i.Name, i.Ticker, i.Market), createElement("td", {
                    style: createObj(toList(delay(() => ((i.NumShares > 0) ? singleton(["color", "var(--buy)"]) : ((i.NumShares < 0) ? singleton(["color", "var(--sell)"]) : empty()))))),
                    children: (i.NumShares > 0) ? "Kjøpt" : ((i.NumShares < 0) ? "Solgt" : "Flyttet/annet"),
                }), createElement("td", {
                    className: "hide-small-screens",
                    style: {
                        textAlign: "right",
                    },
                    children: Format_formatSpacedNumber(i.NumShares),
                })]);
                return createElement("tr", {
                    children: Interop_reactApi.Children.toArray(Array.from(children)),
                });
            }, x_2), createElement("tbody", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            }))]), createElement("table", {
                children: Interop_reactApi.Children.toArray(Array.from(children_4)),
            })));
        }
        else {
            return singleton(LoadingIndicator_skeleton(singleton_1(["height", 307])));
        }
    })))))))));
}

function ShortSummary() {
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(undefined);
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(TopShortEntry_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty_1(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/short/highest-short?num=10`, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(TopShortEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_2) => {
                const res = _arg_2;
                if (res.tag === 0) {
                    patternInput[1](res.fields[0]);
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
        const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder_3, data_5, caseStrategy_10, extra_10;
            return ((decoder_3 = Auto_generateBoxedDecoder_Z6670B51(array_type(ShortEvent_$reflection()), undefined, undefined), (data_5 = undefined, (caseStrategy_10 = undefined, (extra_10 = undefined, (() => {
                let properties_6;
                try {
                    const properties_3_1 = Helper_withProperties(empty_1(), (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty_1()), 0)])]), defaultArg(map_1((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_10, extra_10)(data_1_2))]), properties_6), data_5), properties_6)));
                    const pr_2 = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`${DataServerBaseUrl}/api/short/latest-short`, properties_3_1).then((_arg_3) => {
                        let response_3, decoder_1_2;
                        return ((response_3 = _arg_3, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(array_type(ShortEvent_$reflection()), unwrap(caseStrategy_10), unwrap(extra_10))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_3.text().then((_arg_4) => {
                            let matchValue_1;
                            return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_4), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
                    }))));
                    return pr_2.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])]))));
                }
                catch (exn_1) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
                }
            })()))))).then((_arg_5) => {
                const res_1 = _arg_5;
                if (res_1.tag === 0) {
                    patternInput_1[1](res_1.fields[0]);
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        }));
        pr_3.then();
    });
    return container(singleton_1(section$0027(ofArray([sectionContent(toList(delay(() => append(singleton(h3$0027("Aksjer med høyest andel short")), delay(() => {
        let children_6, children_4;
        const matchValue_2 = patternInput[0];
        if (matchValue_2 != null) {
            const most = matchValue_2;
            return singleton((children_6 = ofArray([thead$0027([["", false, false, empty_1()], ["Ticker", false, false, empty_1()], ["Aksje", false, false, empty_1()], ["Prosent short", false, false, empty_1()]]), (children_4 = mapIndexed((i, m) => {
                let children;
                const children_2 = ofArray([createElement("td", {
                    style: {
                        fontWeight: "bold",
                    },
                    children: i + 1,
                }), tickerTd(m.Ticker, m.Market), assetTd(false, m.Name, m.Ticker, m.Market), (children = singleton_1(createElement("span", {
                    children: [`${m.Percentage / 100}%`],
                })), createElement("td", {
                    children: Interop_reactApi.Children.toArray(Array.from(children)),
                }))]);
                return createElement("tr", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_2)),
                });
            }, most), createElement("tbody", {
                children: Interop_reactApi.Children.toArray(Array.from(children_4)),
            }))]), createElement("table", {
                children: Interop_reactApi.Children.toArray(Array.from(children_6)),
            })));
        }
        else {
            return singleton(LoadingIndicator_skeleton(singleton_1(["height", 307])));
        }
    }))))), sectionContent(toList(delay(() => append(singleton(h3$0027("Siste short-endringer")), delay(() => {
        let children_16, children_14;
        const matchValue_3 = patternInput_1[0];
        if (matchValue_3 != null) {
            const latest = matchValue_3;
            return singleton((children_16 = ofArray([thead$0027([["Ticker", false, false, empty_1()], ["Aksje", false, true, empty_1()], ["Ny prosent short", false, false, empty_1()], ["Endring", false, false, empty_1()]]), (children_14 = map((l) => {
                let children_8, children_10;
                const children_12 = ofArray([tickerTd(l.Ticker, l.Market), createElement("td", {
                    className: "hide-small-screens",
                    children: l.Name,
                }), (children_8 = singleton_1(createElement("span", {
                    children: [`${l.NewPercent / 100}%`],
                })), createElement("td", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_8)),
                })), (children_10 = toList(delay(() => {
                    const matchValue_4 = l.ChangePercent;
                    if (matchValue_4 != null) {
                        const c = matchValue_4 | 0;
                        return append(singleton(createElement("span", {
                            style: {
                                marginRight: 3,
                            },
                            className: (c > 0) ? "fas fa-arrow-up" : "fas fa-arrow-down",
                        })), delay(() => singleton(createElement("span", {
                            children: [`${c / 100}%`],
                        }))));
                    }
                    else {
                        return singleton(createElement("span", {
                            children: ["-"],
                        }));
                    }
                })), createElement("td", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_10)),
                }))]);
                return createElement("tr", {
                    children: Interop_reactApi.Children.toArray(Array.from(children_12)),
                });
            }, latest), createElement("tbody", {
                children: Interop_reactApi.Children.toArray(Array.from(children_14)),
            }))]), createElement("table", {
                children: Interop_reactApi.Children.toArray(Array.from(children_16)),
            })));
        }
        else {
            return singleton(LoadingIndicator_skeleton(singleton_1(["height", 307])));
        }
    })))))]))));
}

function Reviews() {
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    useReact_useEffectOnce_3A5B6456(() => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let decoder, data_1, caseStrategy_2, extra_2;
            return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(ReviewMeta_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                let properties_2;
                try {
                    const properties_3 = Helper_withProperties(empty_1(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/review/latest", properties_3).then((_arg_1) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(ReviewMeta_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_2) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                }
                catch (exn) {
                    return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
            })()))))).then((_arg_3) => {
                const res = _arg_3;
                if (res.tag === 0) {
                    patternInput[1](res.fields[0]);
                    return Promise.resolve();
                }
                else {
                    return Promise.resolve();
                }
            });
        }));
        pr_1.then();
    });
    return container(singleton_1(section$0027(singleton_1(sectionContent(toList(delay(() => append(singleton(h3$0027("Siste analyser fra brukere")), delay(() => append(singleton(createElement("span", {
        children: ["Aksjeanalyser skrevet av aksje.io brukere"],
    })), delay(() => {
        let children_4, children_2;
        const matchValue_2 = patternInput[0];
        if (matchValue_2 != null) {
            const l = matchValue_2;
            return singleton((children_4 = ofArray([thead$0027([["Vurdering", false, false, empty_1()], ["Ticker", false, false, empty_1()], ["Aksje", false, true, empty_1()], ["Bruker", false, false, empty_1()]]), (children_2 = map((r) => {
                let elems_1, elems, matchValue_3, matchValue_1;
                const children = ofArray([createElement("td", createObj(ofArray([["style", {
                    fontWeight: "bold",
                }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                }], (elems = [createElement("i", {
                    className: (matchValue_3 = r.Rating.toLocaleLowerCase(), (matchValue_3 === "kjøp") ? "fas fa-arrow-circle-up" : ((matchValue_3 === "svakt kjøp") ? "fas fa-arrow-circle-right" : ((matchValue_3 === "hold") ? "fas fa-arrow-circle-right" : ((matchValue_3 === "svakt salg") ? "fas fa-arrow-circle-right" : ((matchValue_3 === "selg") ? "fas fa-arrow-circle-down" : "var(--text-main)"))))),
                    style: {
                        color: (matchValue_1 = r.Rating.toLocaleLowerCase(), (matchValue_1 === "kjøp") ? "var(--buy)" : ((matchValue_1 === "svakt kjøp") ? "var(--weak-buy)" : ((matchValue_1 === "hold") ? "var(--hold)" : ((matchValue_1 === "svakt salg") ? "var(--weak-sell)" : ((matchValue_1 === "selg") ? "var(--sell)" : "var(--text-main)"))))),
                        marginRight: 5,
                        fontSize: 1 + "rem",
                    },
                }), createElement("a", {
                    style: {},
                    href: `/post?src=rv&sid=${r.Id}`,
                    children: r.Rating,
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), tickerTd(r.Ticker, r.Market), assetTd(true, r.Asset, r.Ticker, r.Market), createElement("td", {
                    children: [r.Username],
                })]);
                return createElement("tr", {
                    children: Interop_reactApi.Children.toArray(Array.from(children)),
                });
            }, l), createElement("tbody", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            }))]), createElement("table", {
                children: Interop_reactApi.Children.toArray(Array.from(children_4)),
            })));
        }
        else {
            return singleton(LoadingIndicator_skeleton(singleton_1(["height", 307])));
        }
    })))))))))));
}

export function Summary() {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 20,
    }], (elems = [createElement(InsiderTrade, null), createElement(ShortSummary, null), createElement(Reviews, null)], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

